import * as yup from "yup";

export const schema = yup
  .object({
    nome: yup.string().required("Nome é obrigatório"),
    telefone: yup.string().required("Telefone é obrigatório"),
    dataNascimento: yup.string(),
    email: yup.string().email("E-mail inválido").required("E-mail é obrigatório").trim(),
    emailConfirm: yup
      .string()
      .email("E-mail inválido")
      .required("Digite novamente o e-mail")
      .oneOf([yup.ref("email")], "Os e-mails estão diferentes")
      .trim(),
    senha: yup
      .string()
      .min(8, "A senha contém menos do que 8 caracteres")
      .required("Senha é obrigatória")
      .trim(),
    senhaConfirm: yup
      .string()
      .min(8, "A senha contém menos do que 8 caracteres")
      .required("Digite novamente a senha")
      .oneOf([yup.ref("senha")], "As senhas estão diferentes")
      .trim(),
  })
  .required();

export type CustomerFormData = yup.InferType<typeof schema>;
